import moment from 'moment';

interface DownloadFrameParams {
    videoRef: React.MutableRefObject<HTMLVideoElement | null>;
    quality: number;
    range: number[];
    date: string | null;
    selectedCamera: string;
}

const buildFilename = (
    dateStr: string,
    range: number[],
    paramName: string,
    offset: number
): string => {
    const base = moment(dateStr);
    const start = base.clone().add(range[0], 'minutes').format('YYYYMMDDHHmm');
    const end = base
        .clone()
        .add(range[1] + 1, 'minutes')
        .format('YYYYMMDDHHmm');
    return `${paramName}_${start}_${end}_offset_${offset}s.jpg`;
};

export const downloadFrame = ({
    videoRef,
    quality,
    range,
    date,
    selectedCamera,
}: DownloadFrameParams) => {
    if (!videoRef.current) {
        console.error('Video not available');
        return;
    }

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    if (!ctx || !date) return;

    canvas.width = videoRef.current.videoWidth;
    canvas.height = videoRef.current.videoHeight;
    ctx.drawImage(videoRef.current, 0, 0, canvas.width, canvas.height);

    // download jpeg with optional quality param
    canvas.toBlob(
        (blob) => {
            if (!blob) return;

            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;

            // @ts-ignore
            const offsetInSeconds = Math.floor(videoRef.current.currentTime);
            a.download = buildFilename(
                date,
                range,
                selectedCamera,
                offsetInSeconds
            );
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        },
        'image/jpeg',
        quality
    );
};
